import { Analytics } from './analytics';

$('[carousel-slide-tracking-url]').on('click', (e) => {
    const category = 'Carrousel Clicks';
    const action = $(e.currentTarget).attr('href').split('?')[0];
    const label = $(e.target)
        .closest('[carousel-slide-tracking-item]')
        .find('[carousel-slide-tracking-title]')
        .text()
        .trim();
    Analytics.sendEvent(category, action, label);
});

let textSlide = $('[homepage]').find('[slider-text-tracking-arrow]');
textSlide.click((e) => {
    let currentSlide = $(e.target).siblings('[slider-text-tracking-item]').find('.slick-current');

    let index = (parseInt(currentSlide.attr('data-slick-index')) + 1).toString();
    let strongTitle = currentSlide.find('[slider-text-tracking-strong-title]').text();
    let regularTitle = currentSlide.find('[slider-text-tracking-regular-title]').text();

    Analytics.sendEvent('Home page - Benefits Carrousel', `${regularTitle} - ${strongTitle} | ${index}`, '');
});
